import { BaseButton } from '@procurify/ui'
import { ButtonLoaderStyled } from '@procurify/ui'
import { applyButtonColorCSS } from '@procurify/ui'
import { CircleLoader } from '@procurify/ui'
import { em, shade } from 'polished'
import styled from 'styled-components'

export const FilterButtonStyled = styled(BaseButton)`
  ${(props) =>
    applyButtonColorCSS(
      props.theme.colors.white,
      props.theme.colors.lightGrey,
      props.theme.colors.textPrimary,
      shade(0.05, props.theme.colors.white),
      props.theme.colors.lightGrey
    )}

  box-shadow: none;
  font-weight: normal;
  border-radius: ${(props) =>
    props.theme.typography.pxToRem(props.theme.shape.borderRadius)};
  height: ${(props) => `${em(38, props.theme.fontSizes.button)}`};

  &:hover {
    box-shadow: none;
  }

  &[disabled] {
    cursor: not-allowed;
    color: ${(props) => props.theme.colors.disabled};
    background-color: ${(props) => props.theme.colors.white};
    border-color: ${(props) => props.theme.colors.disabled};
    box-shadow: none;

    &:hover,
    &:active {
      color: ${(props) => props.theme.colors.disabled};
      background-color: ${(props) => props.theme.colors.white};
      border-color: ${(props) => props.theme.colors.disabled};
      box-shadow: none;
    }
  }

  ${ButtonLoaderStyled} {
    background-color: ${(props) => props.theme.colors.offwhite};

    ${CircleLoader} {
      border-color: ${(props) => props.theme.colors.disabled};
      border-bottom-color: transparent;
    }
  }
`
